(() => {
  const hydrate = card => {
    if (!card) return;
    card.querySelectorAll('img[data-hover-deferred]').forEach(img => {
      if (img.dataset.src) img.src = img.dataset.src;
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      img.removeAttribute('data-hover-deferred');
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
    });
  };

  const hoverCapable = matchMedia('(hover: hover) and (pointer: fine)');
  document.addEventListener('pointerover', event => {
    if (!hoverCapable.matches) return;
    hydrate(event.target.closest('.product-item'));
  }, { passive: true });

  document.addEventListener('focusin', event => {
    hydrate(event.target.closest('.product-item'));
  });
})();
